import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import uniqueId from "lodash/uniqueId";
import Svg from "../Svg";
var Icon = function(props) {
    var id = uniqueId("svg");
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5.50002 24.1501L4.40002 31.0001H5.35002C5.95002 31.0001 6.15002 30.3001 6.55002 29.4501C7.05002 28.3501 8.25002 25.5001 8.25002 25.5001L5.50002 24.1501ZM26.55 24.1501L27.7 31.0001H26.75C26.15 31.0001 25.95 30.3001 25.55 29.4501C25.05 28.3501 23.85 25.5001 23.85 25.5001L26.55 24.1501ZM6.65002 5.1001L9.60002 8.0501L8.05002 9.6501L5.10002 6.6501L6.65002 5.1001ZM25.45 5.1001L22.5 8.0501L24.05 9.6501L27 6.6501L25.45 5.1001Z",
                fill: "url(#paint0_linear_12_4414)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.05 30.55C23.0087 30.55 28.65 24.8864 28.65 17.9C28.65 10.9136 23.0087 5.25 16.05 5.25C9.09116 5.25 3.44995 10.9136 3.44995 17.9C3.44995 24.8864 9.09116 30.55 16.05 30.55Z",
                fill: "url(#paint1_linear_12_4414)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.05 27.75C21.4624 27.75 25.85 23.3401 25.85 17.9C25.85 12.46 21.4624 8.05005 16.05 8.05005C10.6376 8.05005 6.25 12.46 6.25 17.9C6.25 23.3401 10.6376 27.75 16.05 27.75Z",
                fill: "black"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.85 11.8L11.65 2.85C10.55 1.7 9 1 7.25 1C3.8 1 1 3.85 1 7.3C1 9.05 1.7 10.65 2.85 11.8ZM20.25 2.9L29.15 11.75C30.3 10.6 31 9.05 31 7.3C31 3.85 28.2 1 24.7 1C22.95 1.05 21.4 1.75 20.25 2.9Z",
                fill: "url(#paint2_linear_12_4414)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.3 23.3L15.45 18.05L16.05 18.65L10.9 23.85L10.3 23.3Z",
                fill: "#03F5AE"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.05 19.75C17.0717 19.75 17.9 18.9218 17.9 17.9C17.9 16.8783 17.0717 16.05 16.05 16.05C15.0282 16.05 14.2 16.8783 14.2 17.9C14.2 18.9218 15.0282 19.75 16.05 19.75Z",
                fill: "#03F5AE"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.1 10.8501H16.95V18.3501H15.1V10.8501ZM16.95 16.9501H20.7V18.8001H16.95V16.9501Z",
                fill: "#03F5AE"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_12_4414",
                        x1: "16.05",
                        y1: "5.1001",
                        x2: "16.05",
                        y2: "31.0001",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#58F2C4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#1BC08F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_12_4414",
                        x1: "16.05",
                        y1: "5.25",
                        x2: "16.05",
                        y2: "30.55",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#5DF6C9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#14BA89"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_12_4414",
                        x1: "16",
                        y1: "1",
                        x2: "16",
                        y2: "11.8",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#61F9CC"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#09B280"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
export default Icon;
